export const IDPAutoIcon = () => (
  <svg
    width="103"
    height="102"
    viewBox="0 0 103 102"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_676_571)">
      <rect
        x="8.75"
        y="4"
        width="86"
        height="86"
        rx="16"
        fill="#95D394"
        shape-rendering="crispEdges"
      />
      <g clip-path="url(#clip0_676_571)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M27.9308 20.1278C27.8898 20.2875 27.8679 20.4549 27.8679 20.6274C27.8679 20.7885 27.887 20.9452 27.9229 21.0952V22.2273V23.0856V23.1127V59.1187C27.9229 59.872 28.3463 60.5615 29.0181 60.9023L57.1118 75.1539C58.4422 75.8288 60.0166 74.8621 60.0166 73.3702V63.6274H71.632C73.8411 63.6274 75.632 61.8366 75.632 59.6274V22.6274C75.632 20.4183 73.8411 18.6274 71.632 18.6274H29.8679C29.1105 18.6274 28.4515 19.0484 28.112 19.6692C28.0171 19.7994 27.9524 19.9549 27.9308 20.1278ZM35.808 22.6274L58.9214 34.3526C59.5932 34.6934 60.0166 35.3828 60.0166 36.1362V59.6274H71.632V22.6274H35.808ZM31.9229 57.8906V25.1418L56.0166 37.3642V70.113L31.9229 57.8906Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_676_571"
        x="0.75"
        y="0"
        width="102"
        height="102"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_676_571"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_676_571"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_676_571">
        <rect
          width="56"
          height="56"
          fill="white"
          transform="translate(23.75 19)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const IDPGuidedIcon = () => (
  <svg
    width="102"
    height="102"
    viewBox="0 0 102 102"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_1237_6331)">
      <rect
        x="8"
        y="4"
        width="86"
        height="86"
        rx="16"
        fill="#91A5DD"
        shape-rendering="crispEdges"
      />
      <g clip-path="url(#clip0_1237_6331)">
        <path
          d="M46.0588 19C42.5642 19 39.2127 20.3882 36.7417 22.8593C34.2706 25.3304 32.8824 28.6819 32.8824 32.1765C32.8824 35.6711 34.2706 39.0226 36.7417 41.4936C39.2127 43.9647 42.5642 45.3529 46.0588 45.3529C49.5534 45.3529 52.9049 43.9647 55.376 41.4936C57.8471 39.0226 59.2353 35.6711 59.2353 32.1765C59.2353 28.6819 57.8471 25.3304 55.376 22.8593C52.9049 20.3882 49.5534 19 46.0588 19ZM36.1765 32.1765C36.1765 29.5555 37.2176 27.0419 39.0709 25.1886C40.9242 23.3353 43.4379 22.2941 46.0588 22.2941C48.6798 22.2941 51.1934 23.3353 53.0467 25.1886C54.9 27.0419 55.9412 29.5555 55.9412 32.1765C55.9412 34.7974 54.9 37.3111 53.0467 39.1644C51.1934 41.0177 48.6798 42.0588 46.0588 42.0588C43.4379 42.0588 40.9242 41.0177 39.0709 39.1644C37.2176 37.3111 36.1765 34.7974 36.1765 32.1765ZM29.6179 48.6471C28.7503 48.6436 27.8906 48.8114 27.0881 49.1409C26.2855 49.4704 25.5559 49.9551 24.9411 50.5672C24.3263 51.1792 23.8383 51.9067 23.5052 52.7077C23.1721 53.5088 23.0004 54.3677 23 55.2353C23 60.8056 25.744 65.0056 30.0329 67.7431C34.256 70.4344 39.9482 71.7059 46.0588 71.7059C47.4094 71.7059 48.7468 71.6433 50.0447 71.5181C49.2587 70.5395 48.5764 69.4819 48.0089 68.3624C47.3699 68.3986 46.7176 68.4118 46.0588 68.4118C40.3435 68.4118 35.3299 67.2127 31.8052 64.9628C28.3464 62.7558 26.2941 59.5506 26.2941 55.2353C26.2941 53.4136 27.7699 51.9412 29.6179 51.9412H48.032C48.6381 50.7619 49.3661 49.6584 50.1995 48.6471H29.6212H29.6179ZM62.1176 53.5882C62.1176 53.0422 62.3346 52.5185 62.7207 52.1324C63.1068 51.7463 63.6304 51.5294 64.1765 51.5294C64.7225 51.5294 65.2462 51.7463 65.6323 52.1324C66.0184 52.5185 66.2353 53.0422 66.2353 53.5882C66.2353 54.1343 66.0184 54.6579 65.6323 55.044C65.2462 55.4301 64.7225 55.6471 64.1765 55.6471C63.6304 55.6471 63.1068 55.4301 62.7207 55.044C62.3346 54.6579 62.1176 54.1343 62.1176 53.5882ZM65.8235 66.7647C65.8235 67.2015 65.65 67.6205 65.3411 67.9294C65.0322 68.2382 64.6133 68.4118 64.1765 68.4118C63.7396 68.4118 63.3207 68.2382 63.0118 67.9294C62.7029 67.6205 62.5294 67.2015 62.5294 66.7647V60.1765C62.5294 59.7396 62.7029 59.3207 63.0118 59.0118C63.3207 58.7029 63.7396 58.5294 64.1765 58.5294C64.6133 58.5294 65.0322 58.7029 65.3411 59.0118C65.65 59.3207 65.8235 59.7396 65.8235 60.1765V66.7647ZM49.3529 60.1765C49.3529 56.245 50.9147 52.4746 53.6947 49.6947C56.4746 46.9147 60.245 45.3529 64.1765 45.3529C68.1079 45.3529 71.8783 46.9147 74.6583 49.6947C77.4382 52.4746 79 56.245 79 60.1765C79 64.1079 77.4382 67.8783 74.6583 70.6583C71.8783 73.4382 68.1079 75 64.1765 75C60.245 75 56.4746 73.4382 53.6947 70.6583C50.9147 67.8783 49.3529 64.1079 49.3529 60.1765ZM52.6471 60.1765C52.6471 61.6905 52.9453 63.1898 53.5247 64.5886C54.1041 65.9874 54.9533 67.2584 56.0239 68.329C57.0946 69.3996 58.3655 70.2488 59.7644 70.8283C61.1632 71.4077 62.6624 71.7059 64.1765 71.7059C65.6905 71.7059 67.1898 71.4077 68.5886 70.8283C69.9874 70.2488 71.2584 69.3996 72.329 68.329C73.3996 67.2584 74.2488 65.9874 74.8283 64.5886C75.4077 63.1898 75.7059 61.6905 75.7059 60.1765C75.7059 57.1187 74.4912 54.1861 72.329 52.0239C70.1668 49.8618 67.2343 48.6471 64.1765 48.6471C61.1187 48.6471 58.1861 49.8618 56.0239 52.0239C53.8618 54.1861 52.6471 57.1187 52.6471 60.1765Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_1237_6331"
        x="0"
        y="0"
        width="102"
        height="102"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1237_6331"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1237_6331"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_1237_6331">
        <rect
          width="56"
          height="56"
          fill="white"
          transform="translate(23 19)"
        />
      </clipPath>
    </defs>
  </svg>
);
